var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":_vm.row[_vm.col.field],"target":"_blank"}},[_vm._v(_vm._s(_vm.row[_vm.col.field]))])}
var staticRenderFns = []

export { render, staticRenderFns }